import Detector from './detector';

/**
 * 判断当前app版本是否支持某个功能 一般判定是否 >= 某个版本号，从而确认那个版本之后的才支持
 * @param {currentVersion} | string 当前app版本
 * @param {supportVersion} | string 某个功能支持的版本
 * @return {boolean} true 代表当前版本支持 false 代表不支持
 */

export function versionCompare(currentVersion, supportVersion) {
  const currentVersions = currentVersion.split('.');
  const supportVersions = supportVersion.split('.');

  const currentBV = Number(currentVersions[0]);
  const currentMV = Number(currentVersions[1]);
  const currentSV = Number(currentVersions[2]);

  const supportBV = Number(supportVersions[0]);
  const supportMV = Number(supportVersions[1]);
  const supportSV = Number(supportVersions[2]);
  // console.log(currentBV>supportBV);
  if (currentBV > supportBV) {
    return true;
  }
  if (currentBV >= supportBV && currentMV > supportMV) {
    return true;
  }
  if (currentBV >= supportBV && currentMV >= supportMV && currentSV >= supportSV) {
    return true;
  }

  return false;
}

/**
 * 是否高于某个版本
 * @param version
 * @returns {boolean}
 */
export const isHigherThan = (version) => {
  const currentVersion = Detector.browser.fullVersion;
  return versionCompare(currentVersion, version);
};
